import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const AUTH_PATHS = new Set(["/login", "/signup"]);

const getRedirectPath = (location) => {
  const from = location.state?.from;
  if (!from) return "/";
  const path = typeof from === "string" ? from : from.pathname;
  if (!path || AUTH_PATHS.has(path)) return "/";
  return path;
};

const useAuthPageRedirect = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const redirectTo = getRedirectPath(location);

  const onSuccess = () => navigate(redirectTo, { replace: true });
  const goToLogin = () => navigate("/login", { state: location.state });
  const goToSignup = () => navigate("/signup", { state: location.state });

  return { user, loading, redirectTo, onSuccess, goToLogin, goToSignup };
};

export default useAuthPageRedirect;
